import { Button } from '@mui/material';
import { NavLink } from 'react-router';
import Empty from '@/component/Empty';
import { Skeleton } from '@/component/Skeleton';
import { useChatbot } from '@/feature/chatbot/useChatbot';
import { useTexts } from '@/feature/lang';
import Translate from '../../Translate';

export const NoContent = () => {
  const texts = useTexts().component.chatbot.empty;
  const { chatContext, isChatEmpty } = useChatbot();

  if (!chatContext.isValid) {
    switch (chatContext.invalidReason) {
      case 'equipment-loading':
        return <Skeleton width="100%" height="100%" variant="rectangular" />;
      case 'multiple-equipment-selected':
      case 'no-equipment-selected':
        return <Empty margin="small" text={texts.notASingleEquipment.text} />;
      case 'no-permit':
        return (
          <Empty type="no_permit" margin="small" text={texts.noPermit.text} />
        );
      case 'not-in-fleet':
        return (
          <Empty
            margin="small"
            text={texts.onlyAvailableInFleet.text}
            actions={
              <Button
                to="/fleet"
                color="grey"
                variant="contained"
                component={NavLink}
              >
                <Translate text={texts.onlyAvailableInFleet.action} />
              </Button>
            }
          />
        );
    }
  }

  if (isChatEmpty) {
    return <Empty margin="small" text={texts.noMessages.text} />;
  }

  return <Empty margin="small" />;
};
